import store from './store/index.js'
import config from './config/production.js'
import CustomSearch from './lib/CustomSearch'
import AdvancedSearch from './lib/AdvancedSearch'
import i18n from './i18n/index.js'

// Importacions generiques
import lib from './lib/'
// import components from './components'

import geoportalBoot from './boot'
const boot = geoportalBoot.setup

import AppHeader from 'components/AppHeader'
import AddCustomLayerPanel from 'components/AddCustomLayerPanel'
import AuthHeaderItem from 'components/Header/AuthHeaderItem'
import AuthHeaderMenu from 'components/Header/AuthHeaderMenu'
import CatalogPanel from 'components/CatalogPanel'
import DownloadsPanel from 'components/DownloadsPanel'
import HomeTabsPanel from 'components/HomeTabsPanel'
import LanguagePanel from 'components/LanguagePanel'
import PanoramaPanel from 'components/PanoramaPanel'
import OpenDataPanel from 'components/OpenDataPanel'
import OpenDataResultPanel from 'components/OpenDataResultPanel'
import SearchPanel from 'components/SearchPanel'

import LayerInfo from 'pages/LayerInfo'
import Login from 'pages/Login'
import PanoramasInfo from 'pages/PanoramasInfo'
import ValidateCatalog from 'pages/ValidateCatalog'

import BasicLayout from 'layouts/BasicLayout'
import SimpleLayout from 'layouts/SimpleLayout'

export {
  AppHeader,
  AddCustomLayerPanel,
  AuthHeaderItem,
  AuthHeaderMenu,
  CatalogPanel,
  DownloadsPanel,
  HomeTabsPanel,
  LanguagePanel,
  PanoramaPanel,
  OpenDataPanel,
  OpenDataResultPanel,
  SearchPanel,

  LayerInfo,
  Login,
  PanoramasInfo,
  ValidateCatalog,

  BasicLayout,
  SimpleLayout,

  boot,
  store,
  CustomSearch,
  AdvancedSearch,
  config,
  i18n,
  // components,
  lib
}
